import { render } from "./AttendanceSetting.vue?vue&type=template&id=2baf35c6"
import script from "./AttendanceSetting.vue?vue&type=script&lang=js"
export * from "./AttendanceSetting.vue?vue&type=script&lang=js"

import "./AttendanceSetting.vue?vue&type=style&index=0&id=2baf35c6&lang=css"
import "./AttendanceSetting.vue?vue&type=style&index=1&id=2baf35c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__